import { ComponentProps, FC, ReactNode } from 'react';
import { Button } from '../Button';

type IconButtonProps = {
  trailingIcon?: ReactNode;
  leadingIcon?: ReactNode;
} & Omit<ComponentProps<typeof Button>, 'children'>;

export const IconButton: FC<IconButtonProps> = ({ leadingIcon, trailingIcon, text, ...rest }) => {
  return (
    <Button {...rest}>
      {leadingIcon}
      {text}
      {trailingIcon}
    </Button>
  );
};
